import type { MouseEvent } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel'
import { usePrivacyPolicyDocument } from 'shared/hooks'
import { CheckBoxSimple } from 'shared/ui/check-box-simple'

import s from './styles.module.scss'

interface PolicyAgreementProps {
  isAccepted: boolean
  onToggle: () => void
}

export const PolicyAgreement = ({
  isAccepted,
  onToggle,
}: PolicyAgreementProps) => {
  const { t } = useTranslation()
  const { openPrivacyPolicy } = usePrivacyPolicyDocument()

  const handleLinkClick = (
    event: MouseEvent<HTMLSpanElement>,
    field: keyof PrivacyPolicyModel,
  ) => {
    event.stopPropagation()
    void openPrivacyPolicy(field)
  }

  return (
    <label
      className={s.agreement}
      onClick={onToggle}
    >
      <CheckBoxSimple isChecked={isAccepted} />
      <p className={clsx('regular-12', s.text)}>
        {t('kyrgyzstan_block.booking.summary.agreement')}{' '}
        <span
          className={s.link}
          onClick={(event) => handleLinkClick(event, 'kyrgyzstan_public_offer')}
        >
          {t('kyrgyzstan_block.booking.summary.offer')}
        </span>{' '}
        {t('kyrgyzstan_block.booking.summary.and')}{' '}
        <span
          className={s.link}
          onClick={(event) => handleLinkClick(event, 'base_public_offer')}
        >
          {t('kyrgyzstan_block.booking.summary.privacy')}
        </span>
      </p>
    </label>
  )
}
